import React from 'react';
import { DeviceDetailPage } from '../../../components/DeviceDetailPage';

export const DevicesOrganizationDeviceDetails: React.FC = () => (
    <DeviceDetailPage
        testId="device-organization-device-details-page"
        appRoute={{
            type: 'DevicesOrganization',
        }}
    />
);
